import { useEffect, useState } from "react";
import SummaryApi from "../../common";
import { Pencil, TruckElectric } from "lucide-react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";

function YatraList() {
  const [yatras, setYatras] = useState([]);
  const [selectedYatra, setSelectedYatra] = useState(null);
  const [varkaris, setVarkaris] = useState([]);
  const [railwayTicket, setRailwayTicket] = useState("");
  const [busTicket, setBusTicket] = useState("");
  const [kirana, setKirana] = useState("");
  const [roomhotel, setroomhotel] = useState("");
  const [otherexpense, setotherexpense] = useState("");
  const [showVarkariModal, setShowVarkariModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [allvarkaris, setallVarkaris] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVarkariIds, setSelectedVarkariIds] = useState([]);
  const [editVarkari, setEditVarkari] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPaymentData, setSelectedPaymentData] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [selectedVarkariDetail, setSelectedVarkariDetail] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [railwayTicket2, setRailwayTicket2] = useState("");
  const [busTicket2, setBusTicket2] = useState("");
  const [advanceBooking, setAdvanceBooking] = useState(0);
  const [newVarkari, setNewVarkari] = useState({
    name: "",
    age: "",
    mobileNo: "",
    aadharCardNo: "",
    address: "",
    apang: false,
    agreedTerms: true,
  });
const navigate = useNavigate();

  const handleCreateVarkari = async () => {
    if (!newVarkari.agreedTerms) {
      alert("कृपया अटी व शर्ती स्वीकारा.");
      return;
    }

    try {
      const response = await fetch(SummaryApi.createVarkari.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...newVarkari,
          yatraId: selectedYatra._id,
          yatraName: selectedYatra.yatraName,
          price: selectedYatra.pricePerPerson,
          booking: "Accepted",
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        alert("वारकरी तयार करताना त्रुटी: " + (result.error || result.message));
        return;
      }

      // Success
      setShowVarkariModal(false);
      setNewVarkari({
        name: "",
        age: "",
        mobileNo: "",
        aadharCardNo: "",
        address: "",
        apang: false,
        agreedTerms: true,
      });

      // Update list
      setVarkaris((prev) => [...prev, result.varkari]);
    } catch (err) {
      alert("Server Error: " + err.message);
    }
  };
  const handleUpdateVarkari = async () => {
    try {
      const res = await fetch(
        `${SummaryApi.updateVarkari.url}/${editVarkari._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...editVarkari,
            yatraId: selectedYatra._id, // 🔥 ADD THIS
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        toast.success("वारकरी अपडेट झाला ✅");

        // update UI instantly
        setVarkaris((prev) =>
          prev.map((v) => (v._id === editVarkari._id ? data.varkari : v)),
        );

        setShowEditModal(false);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  const handleAddPayment = async () => {
    try {
      const res = await fetch(SummaryApi.addPayment.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          varkariId: selectedPaymentData.varkariId,
          yatraId: selectedPaymentData.yatraId,
          amount: paymentAmount,
          date: paymentDate, // 🔥 send manual date
        }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("हप्ता यशस्वीरीत्या जमा झाला ✅");

        // update UI
        setVarkaris((prev) =>
          prev.map((v) =>
            v._id === selectedPaymentData.varkariId
              ? {
                  ...v,
                  yatra: v.yatra.map((y) =>
                    y.yatraId === selectedPaymentData.yatraId ||
                    y.yatraId?._id === selectedPaymentData.yatraId
                      ? data.yatra
                      : y,
                  ),
                }
              : v,
          ),
        );

        setShowPaymentModal(false);
        setPaymentAmount("");
        setPaymentDate("");
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  useEffect(() => {
    if (selectedYatra?.financialSummary) {
      const s = selectedYatra.financialSummary;

      setRailwayTicket(Number(s.railwayTicket) || 0);
      setRailwayTicket2(Number(s.railwayTicket2) || 0);

      setBusTicket(Number(s.busTicket) || 0);
      setBusTicket2(Number(s.busTicket2) || 0);

      setKirana(Number(s.kirana) || 0);
      setroomhotel(Number(s.roomhotel) || 0);
      setotherexpense(Number(s.otherexpense) || 0);

      setAdvanceBooking(Number(s.advanceBooking) || 0); // ✅ NEW
    }
  }, [selectedYatra]);

  useEffect(() => {
    const fetchYatras = async () => {
      try {
        const response = await fetch(SummaryApi.getAllYatra.url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (Array.isArray(data)) {
          setYatras(data);
        } else {
          console.warn("Unexpected response structure:", data);
        }
      } catch (error) {
        console.error("Error fetching yatras:", error);
      }
    };

    fetchYatras();
  }, []);

  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB").format(new Date(date));

  const handleClick = async (yatra) => {
    setSelectedYatra(yatra);

    try {
      const response = await fetch(
        `${SummaryApi.getVarkarisByYatraId.url}/${yatra._id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setVarkaris(data);
      } else {
        console.warn("Unexpected Varkari response:", data);
        setVarkaris([]);
      }
    } catch (error) {
      console.error("Error fetching varkari list:", error);
      setVarkaris([]);
    }
  };

  const handleBack = () => {
    setSelectedYatra(null);
  };

  const filteredVarkaris = selectedYatra
    ? varkaris
        .filter((v) =>
          v.yatra.some(
            (y) =>
              (y.yatraId === selectedYatra._id ||
                y.yatraId?._id === selectedYatra._id) &&
              y.booking === "Accepted",
          ),
        )
        .map((varkari) => {
          const currentYatra = varkari.yatra.find(
            (y) =>
              y.yatraId === selectedYatra._id ||
              y.yatraId?._id === selectedYatra._id,
          );
          const price = currentYatra?.price ?? 0;
          const paid = currentYatra?.paidAmount ?? 0;
          const baki = price - paid;

          return { varkari, price, paid, baki, currentYatra };
        })
    : [];

  const totalPrice = filteredVarkaris.reduce((sum, v) => sum + v.price, 0);
  const totalPaid = filteredVarkaris.reduce((sum, v) => sum + v.paid, 0);
  const totalBaki = filteredVarkaris.reduce((sum, v) => sum + v.baki, 0);

  const saveFinancialData = async () => {
    const payload = {
      railwayTicket,
      railwayTicket2, // ✅ new
      busTicket,
      busTicket2,
      advanceBooking, // ✅ new
      kirana,
      roomhotel,
      otherexpense,
      totalammount: totalPrice,
      totalCollectedAmount: totalPaid,
    };

    try {
      const response = await fetch(
        `${SummaryApi.saveFinancialSummary.url}/${selectedYatra._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        alert("आर्थिक सारांश जतन झाला.");
        window.location.reload();
      } else {
        alert("काहीतरी चूक झाली.");
      }
    } catch (error) {
      console.error(error);
      alert("सर्वर एरर.");
    }
  };

  const handleRemoveVarkari = async (varkariId, yatraId) => {
    if (!window.confirm("तुम्हाला हे वारकरी यात्रा मधून काढायचे आहे का?"))
      return;

    try {
      // 🔧 Call your backend API here
      const response = await fetch(SummaryApi.removeYatraFromVarkari.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ varkariId, yatraId }),
      });

      const result = await response.json();

      if (response.ok) {
        // ✅ Re-fetch or update state
        alert("वारकरी यशस्वीरित्या काढण्यात आले.");
        // Optionally update local state:
        setVarkaris((prev) =>
          prev.map((v) =>
            v._id === varkariId
              ? {
                  ...v,
                  yatra: v.yatra.filter(
                    (y) => y.yatraId !== yatraId && y.yatraId?._id !== yatraId,
                  ),
                }
              : v,
          ),
        );
      } else {
        alert(result.message || "काहीतरी चूक झाली.");
      }
    } catch (error) {
      console.error("Remove error:", error);
      alert("वारकरी काढता आले नाही.");
    }
  };

  const fetchVarkaris = async () => {
    setLoading(true);
    try {
      const response = await fetch(SummaryApi.getAllVarkaris.url);
      const data = await response.json();
      setallVarkaris(data);
    } catch (error) {
      console.error("Error fetching Varkaris:", error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    setShowAddModal(true);
    fetchVarkaris();
  };

  const handleCheckboxChange = (e, varkariId) => {
    if (e.target.checked) {
      setSelectedVarkariIds((prev) => [...prev, varkariId]);
    } else {
      setSelectedVarkariIds((prev) => prev.filter((id) => id !== varkariId));
    }
  };

  const handleAddSelectedVarkaris = async () => {
    try {
      // Call your API to update each selected varkari's yatra array
      await Promise.all(
        selectedVarkariIds.map((id) =>
          fetch(`${SummaryApi.addYatraToMultipleVarkaris.url}/${id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              yatraId: selectedYatra._id,
              yatraName: selectedYatra.yatraName,
              price: selectedYatra.pricePerPerson,
              booking: "Accepted",
            }),
          }),
        ),
      );
      alert("Varkaris added successfully!");
      setShowAddModal(false);
      setSelectedVarkariIds([]);
      fetchVarkaris();
    } catch (error) {
      console.error("Error adding varkaris:", error);
      alert("Failed to add varkaris.");
    }
  };

  const handleCompleteYatra = async () => {
    // Ask for confirmation
    const confirmAction = window.confirm(
      "आपण नक्की ही यात्रा पूर्ण करायची आहे का?",
    );
    if (!confirmAction) return;

    try {
      const response = await fetch(
        `${SummaryApi.updateYatra.url}/${selectedYatra._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ status: "complete" }),
        },
      );

      if (response.ok) {
        toast.success("यात्रा यशस्वीरीत्या पूर्ण झाली! 🙏", {
          position: "top-right",
          autoClose: 3000,
        });
        // 👉 Optionally refetch the yatra data or update state here
      } else {
        toast.error("अपडेट करताना त्रुटी आली.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating yatra status:", error);
      toast.error("सर्व्हर त्रुटी आली.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleGenerateReceipt = (data, selectedYatra) => {
    const receiptWindow = window.open("", "_blank");
    receiptWindow.document.write(`
    <html>
      <head>
        <title>बुकिंग पावती</title>
        <style>
          body { font-family: sans-serif; padding: 20px; }
          .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
          }
          .header img {
            width: 100px;
            height: auto;
            opacity: 0.9;
          }
          .header-text {
            text-align: center;
            flex: 1;
            margin: 0 20px;
          }
          .header-text h1 {
            font-size: 22px;
            margin: 0;
          }
          .header-text p {
            margin: 5px 0 0;
            font-size: 14px;
            color: #444;
          }
          h2 { text-align: center; margin-bottom: 5px; }
          h3 { text-align: center; margin-top: 0; color: #d35400; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          td, th { border: 1px solid #333; padding: 8px; text-align: left; }
          .footer {
            margin-top: 40px;
            text-align: center;
          }
          .confirm-heading {
            text-align: center;
            margin-top: 100px;
            color: #2c3e50;
            font-size: 18px;
            font-weight: bold;
          }
        </style>
      </head>
      <body>

        <!-- Header -->
        <div class="header">
          <img src="/photo1-min.png" alt="Left Decoration">
          <div class="header-text">
            <h1>वारकरी विचार परिवार तीर्थयात्रा</h1>
            <p>चला आपल्या अंतर्मनाचा शोध घेऊयात, आध्यात्मिक प्रवास करूयात</p>
          </div>
          <img src="/photo2-min.png" alt="Right Decoration">
        </div>

        <h2>${selectedYatra?.yatraName || "यात्रा नाव"}</h2>
        <h3>यात्रा बुकिंग पावती</h3>

        <table>
          <tr><th>नाव</th><td>${data.name}</td></tr>
          <tr><th>आधार क्रमांक</th><td>${data.aadhar}</td></tr>
          <tr><th>मोबाइल</th><td>${data.mobile}</td></tr>
          <tr><th>एकूण रक्कम</th><td>₹${data.price}</td></tr>
          <tr><th>जमा रक्कम</th><td>₹${data.paid}</td></tr>
          <tr><th>बाकी रक्कम</th><td>₹${data.baki}</td></tr>
        </table>

       <h3 class="confirm-heading">
  आपले रेल्वे तिकीट कन्फर्म झाले आहे. कृपया खालील प्रवासाची माहिती लक्षपूर्वक वाचा.
</h3>

<table class="ticket-table">
<tr><th>🗓 प्रवासाची तारीख:</th><td>07-डिसेंबर-2025</td></tr>
<tr><th>📍स्थानक (रेल्वे स्टेशन):</th><td>परभणी जंगशन</td></tr>
<tr><th>गाडी क्रमांक:</th><td>14621</td></tr>
  <tr><th>💺 सीट क्रमांक:</th><td></td></tr>
  <tr><th>⏰ गाडीची वेळ:</th><td>12:58 दुपारी</td></tr>
</table>

<style>
  .confirm-heading {
    text-align: center;
    margin-top: 100px;
    margin-bottom: 10px;
    color: #2c3e50;
    font-size: 18px;
  }

  .ticket-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
  }

  .ticket-table th,
  .ticket-table td {
    border: 1px solid #333;
    padding: 10px;
    width: 50%;
    text-align: left;
    font-size: 15px;
  }

  .ticket-table th {
    background-color: #f9f9f9;
    font-weight: 600;
  }
</style>

        <div class="footer">
          <p style="margin-top:10px; font-weight:bold;">आयोजक: - अशोक महाराज सिरसट</p>
        </div>

      </body>
    </html>
  `);
    receiptWindow.document.close();
    receiptWindow.print();
  };

  const handleDownloadExcel = () => {
    // Prepare filtered & sorted data same as your table
    const filteredVarkaris = varkaris
      .filter((v) =>
        v.yatra.some(
          (y) =>
            (y.yatraId === selectedYatra._id ||
              y.yatraId?._id === selectedYatra._id) &&
            y.booking === "Accepted",
        ),
      )
      .map((varkari, index) => {
        const currentYatra = varkari.yatra.find(
          (y) =>
            y.yatraId === selectedYatra._id ||
            y.yatraId?._id === selectedYatra._id,
        );

        const price = currentYatra?.price ?? 0;
        const paid = currentYatra?.paidAmount ?? 0;
        const baki = price - paid;

        return {
          क्रमांक: index + 1,
          "आधार कार्ड नंबर": varkari.aadharCardNo,
          नाव: varkari.name,
          वय: varkari.age,
          "मोबाइल क्रमांक": varkari.mobileNo,
          रक्कम: `₹${price}`,
          "जमा रक्कम": `₹${paid}`,
          "बाकी रक्कम": `₹${baki}`,
        };
      });

    // Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(filteredVarkaris);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "यात्रेकरू यादी");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${selectedYatra?.yatraName || "Yatra"}_यादी.xlsx`);
  };

  return (
    <div>
      {selectedYatra ? (
        <div className="bg-white p-6 rounded-lg shadow-md">
          <button
            onClick={handleBack}
            className="mb-4 text-blue-600 hover:underline"
          >
            ← यादीकडे परत
          </button>
          <h3 className="text-2xl font-bold text-orange-600 mb-2">
            {selectedYatra.yatraName}
          </h3>
          <p className="text-gray-700 mb-1">
            स्थान: {selectedYatra.visitingPlaces || "माहिती उपलब्ध नाही"}
          </p>
          <p className="text-gray-700 mb-1">
            प्रति व्यक्ती दर: ₹
            {selectedYatra.pricePerPerson || "दर उपलब्ध नाही"}
          </p>
          <p className="text-gray-700 mb-4">
            तारीख: {formatDate(selectedYatra.startDate)}
          </p>

          {selectedYatra.status === "upcoming" && (
            <button
              onClick={handleCompleteYatra}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 mb-4"
            >
              यात्रा पूर्ण करा
            </button>
          )}
           <button
    onClick={() => navigate(`/dashboard/yatra-list/train-details/${selectedYatra._id}`)}
    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 mb-4 ml-5"
  >
    Train Details
  </button>

          <h4 className="text-lg font-semibold mb-2">
            विनंती आलेले वारकरी (Pending):
          </h4>
          {varkaris.length > 0 ? (
            <>
              {/* First Table – Pending Requests */}
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-2">Sr. No</th>
                      <th className="border p-2">नाव</th>
                      <th className="border p-2">Mobile No</th>
                      <th className="border p-2">Booking Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {varkaris
                      .filter((v) =>
                        v.yatra.some(
                          (y) =>
                            (y.yatraId === selectedYatra._id ||
                              y.yatraId?._id === selectedYatra._id) &&
                            y.booking === "Pending",
                        ),
                      )
                      .map((varkari, index) => {
                        const currentYatra = varkari.yatra.find(
                          (y) =>
                            y.yatraId === selectedYatra._id ||
                            y.yatraId?._id === selectedYatra._id,
                        );

                        return (
                          <tr key={varkari._id}>
                            <td className="border p-2 text-center">
                              {index + 1}
                            </td>
                            <td className="border p-2">{varkari.name}</td>
                            <td className="border p-2">{varkari.mobileNo}</td>
                            <td className="border p-2">
                              {currentYatra?.booking}
                              <button
                                className="ml-2 px-2 py-1 text-sm text-white bg-green-600 hover:bg-green-700 rounded"
                                onClick={async () => {
                                  try {
                                    const res = await fetch(
                                      SummaryApi.updateBookingStatus.url,
                                      {
                                        method: "PUT",
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          varkariId: varkari._id,
                                          yatraId: selectedYatra._id,
                                          bookingStatus: "Accepted",
                                        }),
                                      },
                                    );
                                    const result = await res.json();

                                    if (res.ok) {
                                      setVarkaris((prev) =>
                                        prev.map((v) =>
                                          v._id === varkari._id
                                            ? {
                                                ...v,
                                                yatra: v.yatra.map((y) =>
                                                  y.yatraId ===
                                                    selectedYatra._id ||
                                                  y.yatraId?._id ===
                                                    selectedYatra._id
                                                    ? {
                                                        ...y,
                                                        booking: "Accepted",
                                                      }
                                                    : y,
                                                ),
                                              }
                                            : v,
                                        ),
                                      );
                                    } else {
                                      alert("अयशस्वी: " + result.message);
                                    }
                                  } catch (error) {
                                    alert("त्रुटी: " + error.message);
                                  }
                                }}
                              >
                                Accept
                              </button>
                              <button
                                onClick={() =>
                                  handleRemoveVarkari(
                                    varkari._id,
                                    currentYatra?.yatraId,
                                  )
                                }
                                className="ml-2 px-2 py-1 text-sm text-white bg-red-600 hover:bg-red-700 rounded"
                              >
                                Decline
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              {/* Second Table – Accepted */}
              <h4 className="text-lg font-semibold mb-2">
                निश्चित वारकरी (Accepted):
              </h4>
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border p-2">क्रमांक</th>
                      <th className="border p-2">आधार कार्ड नंबर</th>
                      <th className="border p-2">नाव</th>
                      <th className="border p-2">वय</th>
                      <th className="border p-2">मोबाइल क्रमांक</th>
                      <th className="border p-2">रक्कम</th>
                      <th className="border p-2">जमा रक्कम</th>
                      <th className="border p-2">बाकी रक्कम</th>
                      <th className="border p-2">पावती</th>
                    </tr>
                  </thead>
                  <tbody>
                    {varkaris
                      .filter((v) =>
                        v.yatra.some(
                          (y) =>
                            (y.yatraId === selectedYatra._id ||
                              y.yatraId?._id === selectedYatra._id) &&
                            y.booking === "Accepted",
                        ),
                      )
                      .map((varkari) => {
                        const currentYatra = varkari.yatra.find(
                          (y) =>
                            y.yatraId === selectedYatra._id ||
                            y.yatraId?._id === selectedYatra._id,
                        );

                        const price = currentYatra?.price ?? 0;
                        const paid = currentYatra?.paidAmount ?? 0;
                        const baki = price - paid;

                        return { varkari, price, paid, baki, currentYatra };
                      })
                      .sort((a, b) => {
                        // Show baki > 0 first, then baki == 0
                        if (a.baki === 0 && b.baki !== 0) return 1;
                        if (a.baki !== 0 && b.baki === 0) return -1;
                        return 0;
                      })
                      .map(
                        (
                          { varkari, price, paid, baki, currentYatra },
                          index,
                        ) => (
                          <tr
                            key={varkari._id}
                            onClick={() => {
                              setSelectedVarkariDetail({
                                varkari,
                                currentYatra,
                                price,
                                paid,
                                baki,
                              });
                              setShowDetailModal(true);
                            }}
                            className="cursor-pointer hover:bg-gray-100"
                          >
                            <td className="border p-2 text-center">
                              {index + 1}
                            </td>
                            <td className="border p-2">
                              {varkari.aadharCardNo}
                            </td>
                            <td
                              className={`border p-2 font-semibold ${
                                baki === 0 ? "text-green-600" : "text-red-600"
                              }`}
                            >
                              {varkari.name}
                            </td>
                            <td className="border p-2">{varkari.age}</td>
                            <td className="border p-2">{varkari.mobileNo}</td>
                            <td className="border p-2 text-right">₹{price}</td>
                            <td className="border p-2 text-right">
                              <div className="flex justify-between items-center">
                                ₹{paid}
                              </div>
                            </td>
                            <td
                              className={`border p-2 text-right ${
                                baki > 0
                                  ? "text-red-600 font-semibold"
                                  : " text-green-600"
                              }`}
                            >
                              ₹{baki}
                            </td>
                            <td className="border p-2 text-center">
                              <button
                                onClick={() =>
                                  handleGenerateReceipt(
                                    {
                                      name: varkari.name,
                                      aadhar: varkari.aadharCardNo,
                                      mobile: varkari.mobileNo,
                                      price,
                                      paid,
                                      baki,
                                    },
                                    selectedYatra,
                                  )
                                }
                                className="bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-700"
                              >
                                पावती
                              </button>
                            </td>
                          </tr>
                        ),
                      )}
                  </tbody>
                </table>
                <div className="mt-4 text-right"></div>
              </div>

              <div className="flex justify-end gap-4 mt-6">
                <button
                  onClick={handleDownloadExcel}
                  className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                  डाउनलोड एक्सेल
                </button>
                <button
                  onClick={openModal}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg shadow text-sm font-semibold"
                >
                  वारकरी निवडा
                </button>

                <button
                  onClick={() => setShowVarkariModal(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg shadow text-sm font-semibold"
                >
                  नवीन वारकरी जोडा
                </button>
              </div>

              {showDetailModal && selectedVarkariDetail && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                  <div className="bg-white w-[500px] rounded-lg shadow-lg overflow-hidden">
                    {/* HEADER */}
                    <div className="bg-orange-600 text-white px-4 py-3 flex justify-between">
                      <h2 className="text-lg font-semibold">वारकरी माहिती</h2>
                      <button onClick={() => setShowDetailModal(false)}>
                        ✕
                      </button>
                    </div>

                    {/* BODY */}
                    <div className="p-4 space-y-2">
                      <p>
                        <strong>नाव:</strong>{" "}
                        {selectedVarkariDetail.varkari.name}
                      </p>
                      <p>
                        <strong>मोबाइल:</strong>{" "}
                        {selectedVarkariDetail.varkari.mobileNo}
                      </p>
                      <p>
                        <strong>आधार:</strong>{" "}
                        {selectedVarkariDetail.varkari.aadharCardNo}
                      </p>
                      <p>
                        <strong>वय:</strong> {selectedVarkariDetail.varkari.age}
                      </p>
                      <p>
                        <strong>पत्ता:</strong>{" "}
                        {selectedVarkariDetail.varkari.address}
                      </p>

                      <hr />

                      <p>
                        <strong>एकूण:</strong> ₹{selectedVarkariDetail.price}
                      </p>
                      <p>
                        <strong>जमा:</strong> ₹{selectedVarkariDetail.paid}
                      </p>
                      <p className="text-red-600 font-semibold">
                        बाकी: ₹{selectedVarkariDetail.baki}
                      </p>

                      {/* 🔥 PAYMENT HISTORY */}
                      <div>
                        <h3 className="font-semibold mt-3">
                          हप्त्यांचा इतिहास:
                        </h3>

                        {selectedVarkariDetail.currentYatra?.payments?.length >
                        0 ? (
                          <ul className="max-h-32 overflow-y-auto text-sm">
                            {selectedVarkariDetail.currentYatra.payments.map(
                              (p, i) => (
                                <li key={i} className="border-b py-1">
                                  ₹{p.amount} -{" "}
                                  {new Date(p.date).toLocaleDateString()}
                                </li>
                              ),
                            )}
                          </ul>
                        ) : (
                          <p className="text-gray-500 text-sm">
                            कोणताही हप्ता नाही
                          </p>
                        )}
                      </div>
                      <hr />

                      <h3 className="font-semibold mt-2 mb-2">
                        🚆 ट्रेन माहिती
                      </h3>

                      <div className="grid grid-cols-2 gap-4 text-sm">
                        {/* 🚆 GOING */}
                        <div className="border rounded p-2 bg-gray-50">
                          <p className="font-semibold text-green-700 mb-1">
                            Going
                          </p>

                          <p>
                            <span className="font-medium">PNR:</span>{" "}
                            {selectedVarkariDetail.currentYatra?.trainDetails
                              ?.going?.pnrNo || "-"}
                          </p>

                          <p>
                            <span className="font-medium">Bogie:</span>{" "}
                            {selectedVarkariDetail.currentYatra?.trainDetails
                              ?.going?.bogieNo || "-"}
                          </p>

                          <p>
                            <span className="font-medium">Seat:</span>{" "}
                            {selectedVarkariDetail.currentYatra?.trainDetails
                              ?.going?.seatNo || "-"}
                          </p>
                        </div>

                        {/* 🔁 RETURN */}
                        <div className="border rounded p-2 bg-gray-50">
                          <p className="font-semibold text-blue-700 mb-1">
                            Return
                          </p>

                          <p>
                            <span className="font-medium">PNR:</span>{" "}
                            {selectedVarkariDetail.currentYatra?.trainDetails
                              ?.return?.pnrNo || "-"}
                          </p>

                          <p>
                            <span className="font-medium">Bogie:</span>{" "}
                            {selectedVarkariDetail.currentYatra?.trainDetails
                              ?.return?.bogieNo || "-"}
                          </p>

                          <p>
                            <span className="font-medium">Seat:</span>{" "}
                            {selectedVarkariDetail.currentYatra?.trainDetails
                              ?.return?.seatNo || "-"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* FOOTER ACTIONS */}
                    <div className="flex justify-between p-4 border-t">
                      {/* REMOVE */}
                      <button
                        onClick={() => {
                          handleRemoveVarkari(
                            selectedVarkariDetail.varkari._id,
                            selectedVarkariDetail.currentYatra?.yatraId,
                          );
                          setShowDetailModal(false);
                        }}
                        className="bg-red-600 text-white px-3 py-1 rounded"
                      >
                        Remove
                      </button>

                      <div className="flex gap-2">
                        {/* EDIT */}
                        <button
                          onClick={() => {
                            setEditVarkari({
                              ...selectedVarkariDetail.varkari,
                              trainDetails: selectedVarkariDetail.currentYatra
                                ?.trainDetails || {
                                going: { pnrNo: "", bogieNo: "", seatNo: "" },
                                return: { pnrNo: "", bogieNo: "", seatNo: "" },
                              },
                            });
                            setShowEditModal(true);
                            setShowDetailModal(false);
                          }}
                          className="bg-blue-600 text-white px-3 py-1 rounded"
                        >
                          Edit
                        </button>

                        {/* PAYMENT */}
                        <button
                          onClick={() => {
                            setSelectedPaymentData({
                              varkariId: selectedVarkariDetail.varkari._id,
                              yatraId:
                                selectedVarkariDetail.currentYatra?.yatraId,
                              price: selectedVarkariDetail.price,
                              paid: selectedVarkariDetail.paid,
                            });
                            setShowPaymentModal(true);
                            setShowDetailModal(false);
                          }}
                          className="bg-green-600 text-white px-3 py-1 rounded"
                        >
                          Add Payment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showAddModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                  <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-xl max-h-[80vh] overflow-y-auto relative">
                    <button
                      onClick={() => setShowAddModal(false)}
                      className="absolute top-2 right-2 text-gray-600 hover:text-red-600"
                    >
                      ✕
                    </button>

                    <h2 className="text-xl font-semibold mb-4">All Varkaris</h2>

                    {/* ✅ Add Button */}
                    <button
                      onClick={handleAddSelectedVarkaris}
                      className="mb-4 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    >
                      Add Selected
                    </button>

                    {loading ? (
                      <p>Loading...</p>
                    ) : allvarkaris.length > 0 ? (
                      <ul className="space-y-2">
                        {allvarkaris
                          .filter(
                            (varkari) =>
                              !varkari.yatra?.some(
                                (y) =>
                                  y.yatraId === selectedYatra._id ||
                                  y.yatraId?._id === selectedYatra._id,
                              ),
                          )
                          .map((varkari, index) => (
                            <li
                              key={index}
                              className="border p-2 rounded shadow-sm flex items-center gap-2"
                            >
                              <input
                                type="checkbox"
                                value={varkari._id}
                                checked={selectedVarkariIds.includes(
                                  varkari._id,
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, varkari._id)
                                }
                              />
                              <div>
                                <strong>Name:</strong> {varkari.name} <br />
                                <strong>Mobile:</strong> {varkari.mobileNo}
                              </div>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <p>No Varkaris found.</p>
                    )}
                  </div>
                </div>
              )}

              {showVarkariModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-xl relative">
                    <h2 className="text-xl font-bold mb-4 text-orange-600">
                      नवीन वारकरी जोडा
                    </h2>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleCreateVarkari();
                      }}
                      className="space-y-4"
                    >
                      <div>
                        <label className="block font-semibold">नाव:</label>
                        <input
                          type="text"
                          value={newVarkari.name}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              name: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">वय:</label>
                        <input
                          type="number"
                          value={newVarkari.age}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              age: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">
                          मोबाइल नंबर:
                        </label>
                        <input
                          type="text"
                          value={newVarkari.mobileNo}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              mobileNo: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">
                          आधार कार्ड नंबर:
                        </label>
                        <input
                          type="text"
                          value={newVarkari.aadharCardNo}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              aadharCardNo: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                        />
                      </div>

                      <div>
                        <label className="block font-semibold">पत्ता:</label>
                        <textarea
                          value={newVarkari.address}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              address: e.target.value,
                            })
                          }
                          className="w-full border px-3 py-1 rounded"
                          required
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={newVarkari.apang}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              apang: e.target.checked,
                            })
                          }
                        />
                        <label>अपंग आहात का?</label>
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={newVarkari.agreedTerms}
                          onChange={(e) =>
                            setNewVarkari({
                              ...newVarkari,
                              agreedTerms: e.target.checked,
                            })
                          }
                          required
                        />
                        <label>मी अटी व शर्ती स्वीकारतो.</label>
                      </div>

                      <div className="flex justify-end gap-4 pt-2">
                        <button
                          type="button"
                          className="text-gray-600 hover:text-gray-800"
                          onClick={() => setShowVarkariModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                        >
                          जतन करा
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {showEditModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                  <div className="bg-white rounded-lg w-96 shadow-lg overflow-hidden">
                    {/* 🔥 Header */}
                    <div className="bg-blue-600 text-white px-4 py-3 flex justify-between items-center">
                      <h2 className="text-lg font-semibold">
                        वारकरी संपादित करा
                      </h2>
                      <button
                        onClick={() => setShowEditModal(false)}
                        className="text-white text-xl font-bold"
                      >
                        ×
                      </button>
                    </div>

                    {/* 🔹 Body */}
                    <div className="p-4">
                      <input
                        type="text"
                        placeholder="नाव"
                        value={editVarkari?.name || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            name: e.target.value,
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="number"
                        placeholder="वय"
                        value={editVarkari?.age || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            age: e.target.value,
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="text"
                        placeholder="मोबाइल"
                        value={editVarkari?.mobileNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            mobileNo: e.target.value,
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="text"
                        placeholder="आधार"
                        value={editVarkari?.aadharCardNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            aadharCardNo: e.target.value,
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <textarea
                        placeholder="पत्ता"
                        value={editVarkari?.address || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            address: e.target.value,
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />
                      <hr className="my-3" />

                      <h3 className="font-semibold text-gray-700 mb-2">
                        🚆 Going Train
                      </h3>

                      <input
                        type="text"
                        placeholder="PNR No"
                        value={editVarkari?.trainDetails?.going?.pnrNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            trainDetails: {
                              ...editVarkari.trainDetails,
                              going: {
                                ...editVarkari.trainDetails?.going,
                                pnrNo: e.target.value,
                              },
                            },
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="text"
                        placeholder="Bogie No"
                        value={editVarkari?.trainDetails?.going?.bogieNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            trainDetails: {
                              ...editVarkari.trainDetails,
                              going: {
                                ...editVarkari.trainDetails?.going,
                                bogieNo: e.target.value,
                              },
                            },
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="text"
                        placeholder="Seat No"
                        value={editVarkari?.trainDetails?.going?.seatNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            trainDetails: {
                              ...editVarkari.trainDetails,
                              going: {
                                ...editVarkari.trainDetails?.going,
                                seatNo: e.target.value,
                              },
                            },
                          })
                        }
                        className="w-full mb-3 border p-2 rounded"
                      />

                      <h3 className="font-semibold text-gray-700 mb-2">
                        🔁 Return Train
                      </h3>

                      <input
                        type="text"
                        placeholder="PNR No"
                        value={editVarkari?.trainDetails?.return?.pnrNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            trainDetails: {
                              ...editVarkari.trainDetails,
                              return: {
                                ...editVarkari.trainDetails?.return,
                                pnrNo: e.target.value,
                              },
                            },
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="text"
                        placeholder="Bogie No"
                        value={editVarkari?.trainDetails?.return?.bogieNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            trainDetails: {
                              ...editVarkari.trainDetails,
                              return: {
                                ...editVarkari.trainDetails?.return,
                                bogieNo: e.target.value,
                              },
                            },
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />

                      <input
                        type="text"
                        placeholder="Seat No"
                        value={editVarkari?.trainDetails?.return?.seatNo || ""}
                        onChange={(e) =>
                          setEditVarkari({
                            ...editVarkari,
                            trainDetails: {
                              ...editVarkari.trainDetails,
                              return: {
                                ...editVarkari.trainDetails?.return,
                                seatNo: e.target.value,
                              },
                            },
                          })
                        }
                        className="w-full mb-2 border p-2 rounded"
                      />
                    </div>

                    {/* 🔻 Footer */}
                    <div className="flex justify-end gap-2 p-4 border-t">
                      <button
                        onClick={() => setShowEditModal(false)}
                        className="px-3 py-1 bg-gray-400 text-white rounded"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={handleUpdateVarkari}
                        className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {showPaymentModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
                  <div className="bg-white p-5 rounded-lg w-96">
                    <h2 className="text-lg font-bold mb-3">हप्ता भरा</h2>

                    <p>एकूण रक्कम: ₹{selectedPaymentData?.price}</p>
                    <p>जमा: ₹{selectedPaymentData?.paid}</p>
                    <p className="text-red-600 font-semibold">
                      बाकी: ₹
                      {selectedPaymentData?.price - selectedPaymentData?.paid}
                    </p>

                    <input
                      type="number"
                      placeholder="रक्कम"
                      value={paymentAmount}
                      onChange={(e) => setPaymentAmount(e.target.value)}
                      className="w-full border p-2 mt-3"
                    />

                    <input
                      type="date"
                      value={paymentDate}
                      onChange={(e) => setPaymentDate(e.target.value)}
                      className="w-full border p-2 mt-2"
                    />

                    <div className="flex justify-end gap-2 mt-4">
                      <button
                        onClick={() => setShowPaymentModal(false)}
                        className="bg-gray-400 text-white px-3 py-1 rounded"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={handleAddPayment}
                        className="bg-green-600 text-white px-3 py-1 rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-4 flex justify-end gap-8 text-right text-lg font-semibold">
                <div>एकूण रक्कम: ₹{totalPrice}</div>
                <div>एकूण जमा रक्कम: ₹{totalPaid}</div>
                <div>एकूण बाकी रक्कम: ₹{totalBaki}</div>
              </div>
              <div className="mt-6 w-full flex justify-center md:justify-end">
                <div className="mt-6 flex flex-col gap-4 justify-end">
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      अ‍ॅडव्हान्स बुकिंग खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={advanceBooking}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) =>
                        setAdvanceBooking(Number(e.target.value))
                      }
                    />
                  </div>
                  {/* Railway 1 */}
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      रेल्वे तिकीट खर्च 1 :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={railwayTicket}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setRailwayTicket(Number(e.target.value))}
                    />
                  </div>

                  {/* Railway 2 */}
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      रेल्वे तिकीट खर्च 2 :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={railwayTicket2}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) =>
                        setRailwayTicket2(Number(e.target.value))
                      }
                    />
                  </div>

                  {/* Bus 1 */}
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      बस तिकीट खर्च 1 :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={busTicket}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setBusTicket(Number(e.target.value))}
                    />
                  </div>

                  {/* Bus 2 */}
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      बस तिकीट खर्च 2 :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={busTicket2}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setBusTicket2(Number(e.target.value))}
                    />
                  </div>

                  {/* Other fields */}
                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      किराणा :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={kirana}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setKirana(Number(e.target.value))}
                    />
                  </div>

                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      रूम / हॉटेल खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={roomhotel}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setroomhotel(Number(e.target.value))}
                    />
                  </div>

                  <div className="flex gap-2">
                    <label className="block mb-1 font-semibold w-40">
                      इतर खर्च :
                    </label>
                    <input
                      type="number"
                      className="w-auto border-b"
                      value={otherexpense}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setotherexpense(Number(e.target.value))}
                    />
                  </div>

                  {/* Profit */}
                  <p className="text-lg font-bold text-green-700 mt-4">
                    नफा (Profit): ₹
                    {selectedYatra.financialSummary?.profit ?? "उपलब्ध नाही"}
                  </p>

                  {/* Button */}
                  <div className="mt-6 flex justify-end">
                    <button
                      onClick={saveFinancialData}
                      className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      नफा-तोटा अद्यतन करा
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p className="text-gray-500">कोणताही वारकरी आढळला नाही.</p>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {yatras.filter((yatra) => yatra.status === "upcoming").length > 0 ? (
            yatras
              .filter((yatra) => yatra.status === "upcoming")
              .map((yatra) => (
                <div
                  key={yatra._id}
                  onClick={() => handleClick(yatra)}
                  className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition cursor-pointer"
                >
                  <h3 className="text-xl font-semibold text-orange-600">
                    {yatra.yatraName}
                  </h3>
                  <p className="text-gray-600">
                    तारीख: {formatDate(yatra.startDate)}
                  </p>
                </div>
              ))
          ) : (
            <p>कोणतीही यात्रा उपलब्ध नाही.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default YatraList;
